const DECREMENT_ARROW_KEYS = ["ArrowLeft", "ArrowDown"];
const INCREMENT_ARROW_KEYS = ["ArrowRight", "ArrowUp"];
const ARROW_KEYS = [...DECREMENT_ARROW_KEYS, ...INCREMENT_ARROW_KEYS];
export {
  ARROW_KEYS,
  DECREMENT_ARROW_KEYS,
  INCREMENT_ARROW_KEYS
};
//# sourceMappingURL=Slider.constants.js.map
